import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, PlusCircle, Box, Slash, Circle } from 'react-feather';
import PropTypes from 'prop-types';
import { fetchPut } from '../cruds/remote';
import DownloadButton from '../components/output/DownloadButton';
import { EditButton } from '../components/output/CrudButton';
import getLabel from '../translations/messages';

const ENTITY_ROUTE = 'substances/management';

export const PrintEvaluationButton = ({ resource }) => (
  <span>
    {resource.lastEvaluation ?
      <DownloadButton from={'departmentActivitySubstances/evaluations/' + resource.id}
          type="application/pdf"
          extension="pdf"
          iconType="printer"
          tooltip="substancesManagement.print"
      /> : ''
    }
  </span>
);

export const ViewEvaluationButton = ({ resource }, { locale }) => (
  <span>
    {resource.lastEvaluation ?
      <span className="CrudButton">
        <span className="tooltip">{getLabel(locale, 'substancesManagement.view')}</span>
        <Link to={['', ENTITY_ROUTE, resource.id, 'evaluation', resource.lastEvaluation.id, 'view'].join('/')}>
          <FileText size={18} />
        </Link>
      </span> : ''
    }
  </span>
);

ViewEvaluationButton.contextTypes = {
  locale: PropTypes.string,
};

export const NewEvaluationButton = ({ resource }, { locale }) => {
  let disabled = true;

  if (resource.maxDailyQuantity && resource.maxDailyQuantity.value && resource.maxDailyQuantity.unit &&
      resource.maxActualQuantity && resource.maxActualQuantity.value && resource.maxActualQuantity.unit &&
      resource.contactFrequency && resource.exposureTime && resource.enabled) {
    disabled = false;
  } else if (resource.isSubstanceCancerous || resource.isSubstanceMutagen){
	  if(resource.revelationFrequencyOfUseDaysPre && resource.revelationHandlingTimeMinutesPre && resource.revelationProcessTemperaturePre){
		  disabled = false;
	  }
  }

  if (disabled) {
    let tooltip = getLabel(locale, 'substancesManagement.notAllowed');
    if (!resource.enabled) {
      tooltip = getLabel(locale, 'substancesManagement.disabled');
    }

    return (
      <span className="CrudButton">
        <span className="tooltip">{tooltip}</span>
        <a className="disabled">
          <PlusCircle size={18} />
        </a>
      </span>
    );
  }

  return (
    <span className="CrudButton">
      <span className="tooltip">{getLabel(locale, 'substancesManagement.new')}</span>
      <Link to={'/' + ENTITY_ROUTE + '/' + resource.id + '/evaluation/new'} disabled={disabled}>
        <PlusCircle size={18} />
      </Link>
    </span>
  );
};

NewEvaluationButton.contextTypes = {
  locale: PropTypes.string,
};

export const ArchiveEvaluationButton = ({ resource }, { locale }) => (
  <span>
    {resource.lastEvaluation ?
      <span className="CrudButton">
        <span className="tooltip">{getLabel(locale, 'substancesManagement.archive')}</span>
        <Link to={'/' + ENTITY_ROUTE + '/' + resource.id + '/evaluation/'}>
          <Box size={18} />
        </Link>
      </span> : ''
    }
  </span>
);

ArchiveEvaluationButton.contextTypes = {
  locale: PropTypes.string,
};

const handleDisableDas = (resource, updateResults, toggleModal, locale) => {
  const successMessage = getLabel(locale, 'general.success');
  const errorMessage = getLabel(locale, 'general.errorOccurred');

  toggleModal();

  fetchPut('departmentActivitySubstances/' + resource.id + '/stateToggle', {})
    .then(() => {
        toggleModal(successMessage, null, false);
        updateResults();
    })
    .catch(() => toggleModal(errorMessage, null, false));
};

const ToggleEnableButton = ({ resource, toggleModal, updateResults }, context) => {
  const message = resource.enabled ? getLabel(context.locale, 'general.disable') : getLabel(context.locale, 'general.enable');
  const icon = resource.enabled ? <Slash size={18} /> : <Circle size={18} />;

  return (
    <span className="CrudButton">
      <span className="tooltip">{message}</span>
      <a onClick={() => toggleModal(message + '?',
                    () => handleDisableDas(resource, updateResults, toggleModal, context.locale)
                  )}
      >
        {icon}
      </a>
    </span>
  );
};

ToggleEnableButton.contextTypes = {
  locale: PropTypes.string,
};

export const ActionButtons = ({ resource, url, toggleModal, updateResults }, { locale }) => (
  <div>
  	<EditButton resource={resource} entityRoute={url} />
    <ToggleEnableButton resource={resource} toggleModal={toggleModal} updateResults={updateResults} />
  </div>
);



// WEBPACK FOOTER //
// ./src/main/pages/SubstancesManagementButtons.js